import React from "react";
import "./styles.scss";
import { CubeLoader } from "../CubeLoader/CubeLoader";

interface Props {
  absolutePositioning?: boolean;
}

export const PageLoader = (props: Props) => {
  return (
    <div
      className={`page-loader rounded-box ${
        props.absolutePositioning ? "page-loader-absolute" : ""
      }`}
    >
      <CubeLoader />
    </div>
  );
};
